function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

import memoize from 'lodash.memoize';
import { getAllResources } from '../../api/all';
import selectorError from './selectorError';

export default function byIdSelectorFactory(rootApi, resourceKey) {
  return function (callable) {
    var _ref = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

    var _ref$getId = _ref.getId,
        getId = _ref$getId === undefined ? null : _ref$getId,
        config = _objectWithoutProperties(_ref, ['getId']);

    return function (state, props) {
      var id = getId ? getId(props) : props ? props.id : null;
      if (!id) {
        return selectorError('No ID found on resource');
      }

      return rootApi(function (s) {
        return s.resources[resourceKey][id];
      }, callable, config)(state);
    };
  };
}